import {OneSignal} from 'react-native-onesignal';

interface TagDictionary {
  cart_abandoned?: string;
  purchase_status?: string;
}

class TagManager {
  static setTags(tags: TagDictionary) {
    try {
      OneSignal.User.addTags(tags);

    } catch (error) {
      console.error('Error updating tags:', error);
    }
  }

  static deleteTag(key: string) {
    try {
      OneSignal.User.removeTag(key);

    } catch (error) {
      console.error(`Error deleting tag "${key}":`, error);
    }
  }

  static deleteTags(keys: string[]) {
    try {
      OneSignal.User.removeTags(keys);

    } catch (error) {
      console.error('Error deleting tags:', error);
    }
  }

  static async getTags(): Promise<Record<string, string>> {
    try {
      const tags = await OneSignal.User.getTags();

      return tags;
    } catch (error) {
      console.error('Error fetching tags:', error);
      return {};
    }
  }

  static updateDynamicTags(event: string) {
    const dynamicTags: TagDictionary = {};
    switch (event) {
      case 'cart_abandoned':
        dynamicTags.cart_abandoned = 'true';
        break;
      case 'purchase_completed':
        dynamicTags.purchase_status = 'completed';
        dynamicTags.cart_abandoned = 'false';
        break;
      default:

    }
    if (Object.keys(dynamicTags).length > 0) {
      this.setTags(dynamicTags);
    }
  }
}

export default TagManager;
